<template>
  <div>
    <v-row class="ml-1 my-auto">
      <p class="font-weight-bold mb-0">Events</p>
      <v-progress-circular
        indeterminate
        :size="25"
        v-show="isSavingEvent"
        class="ml-5"
        color="primary"
      ></v-progress-circular>
    </v-row>
    <v-row>
      <v-col sm="12">
        <v-expansion-panels>
          <v-expansion-panel v-for="(event, i) in form.events.length" :key="i">
            <v-expansion-panel-header
              v-slot:default="{ open }"
              :color="
                form.events[i].id
                  ? form.events[i].status == true
                    ? 'green lighten-3'
                    : 'pink lighten-5'
                  : 'blue lighten-5'
              "
            >
              <v-row>
                <v-col sm="6">
                  <v-text-field
                    v-model="form.events[i].name"
                    label="Name *"
                    prepend-inner-icon="mdi-calendar-star"
                    @keypress.enter="save_event(form.events[i])"
                    :error-messages="
                      form.events[i].name == ''
                        ? 'this name field is required'
                        : ''
                    "
                  ></v-text-field>
                </v-col>
                <v-col
                  sm="6"
                  v-if="userPermissions.find((up) => up == 'ADD_ATTENDEE')"
                >
                  <v-autocomplete
                    class="mt-2"
                    v-model="form.events[i].Attendees"
                    :disabled="isUpdating"
                    :items="userItems"
                    chips
                    @input="save_event(form.events[i])"
                    dense
                    color="blue-grey lighten-2"
                    label="Select Invitation"
                    item-text="name"
                    item-value="value"
                    multiple
                    :hint="
                      !is_select_all
                        ? 'Click the checkbox to select all attendees'
                        : 'Click the checkbox to unselect all attendees'
                    "
                    persistent-hint
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="
                          remove_attendee(data.item, form.events[i])
                        "
                      >
                        {{ data.item.initials }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item.name"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                    <template v-slot:append-outer>
                      <v-slide-x-reverse-transition mode="out-in">
                        <v-checkbox
                          @click="selectAll(form.events[i])"
                          v-model="is_select_all"
                          class="mt-0"
                        ></v-checkbox>
                      </v-slide-x-reverse-transition>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- Start Date & Time -->
                <v-col sm="3">
                  <v-datetime-picker
                    label="Select Start Date & Time"
                    v-model="form.events[i].start_date"
                    @input="save_event(form.events[i])"
                    :error-messages="
                      form.events[i].start_date == ''
                        ? 'this start date field is required'
                        : ''
                    "
                  >
                  </v-datetime-picker>
                </v-col>
                <!-- /Start Date & Time -->
                <v-col sm="3" v-if="form.events[i].status != 1">
                  <v-select
                    v-model="form.events[i].status"
                    :items="EventStatusItems"
                    chips
                    item-color="red"
                    label="Status"
                    dense
                    class="mt-2"
                    @input="ChangeEventStatus(form.events[i].id)"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip dark v-if="item.text == 'PENDING'" color="gray">{{
                        item.text
                      }}</v-chip>
                      <v-chip
                        dark
                        v-if="item.text == 'COMPLETED'"
                        color="green"
                        >{{ item.text }}</v-chip
                      >
                    </template>
                  </v-select></v-col
                >
                <v-col sm="3" v-if="form.events[i].status == 1">
                  <v-menu
                    v-model="form.events[i].next_scheduled_date_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="Select Next Schedule Event Start Date & Time"
                        v-model="form.events[i].next_scheduled_date"
                        :id="`NSD_date${i}`"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      :id="`NSD_date${i}`"
                      v-model="form.events[i].next_scheduled_date"
                      @input="save_event(form.events[i])"
                      @change="form.events[i].next_scheduled_date_menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- Duplicate Event Button -->
                <v-col
                  sm="2"
                  v-if="
                    form.events[i].status == 1 && i == form.events.length - 1
                  "
                >
                  <v-btn
                    class="mt-5"
                    small
                    dark
                    color="primary"
                    @click="duplicateEvent(form.events[i])"
                    >Duplicate</v-btn
                  >
                </v-col>
                <!-- /Duplicate Event Button -->
                <v-col sm="4" class="px-0">
                  <!-- Send Event Summary -->
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-2"
                        color="primary"
                        v-bind="attrs"
                        x-large
                        v-on="on"
                        @click="SendEventSummary(form.events[i].id)"
                        icon
                        :loading="form.events[i].isSendingEventSummary"
                        ><v-icon>mdi-email</v-icon></v-btn
                      >
                    </template>
                    <span>Send Event Summary</span>
                  </v-tooltip>
                  <!-- /Send Event Summary -->
                  <!-- Generate Event Excel -->
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                        x-large
                        icon
                        @click="generateExcel(form.events[i].id)"
                        color="primary"
                        :loading="isEventExcelLoading"
                        :disabled="isEventExcelLoading"
                      >
                        <download-excel
                          :title="title"
                          :data="report_excel"
                          :fields="excel_fields"
                          worksheet="Event Report"
                          name="Event-Report.xls"
                        >
                          <v-icon>mdi-microsoft-excel</v-icon>
                        </download-excel>
                      </v-btn>
                    </template>
                    <span>Download Excel </span>
                  </v-tooltip>
                  <!-- /Generate Event Excel -->
                  <!-- Generate Event PDF -->
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                        target="_blank"
                        x-large
                        icon
                        :to="`event-pdf-report/${form.events[i].id}`"
                        color="primary"
                        :loading="generatingPDF"
                        :disabled="generatingPDF"
                      >
                        <!-- @click="createPDF2(form.events[i])" -->
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-btn>
                    </template>
                    <span>Download PDF </span>
                  </v-tooltip>
                  <!-- /Generate Event PDF -->
                  <!-- Event Concerns Button -->
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-2"
                        color="primary"
                        icon
                        v-bind="attrs"
                        x-large
                        v-on="on"
                        @click="show_event_concerns(form.events[i].id)"
                      >
                        <v-badge
                          overlap
                          color="pink"
                          right
                          :content="form.events[i].event_concerns.length"
                        >
                          <v-icon>mdi-comment-plus-outline </v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                    <span
                      >View
                      {{ form.events[i].event_concerns?.length || 0 }}
                      Event Concerns
                    </span>
                  </v-tooltip>
                  <!-- /Event Concerns Button -->
                  <!-- Delete Event Button -->
                  <v-dialog
                    v-if="userPermissions.find((up) => up == 'DELETE_EVENT')"
                    v-model="isDeleteEventDialogs[i]"
                    max-width="600px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn fab x-small dark color="red" class="mx-3">
                        <v-icon dark v-bind="attrs" v-on="on">
                          mdi-close-thick
                        </v-icon>
                      </v-btn>
                    </template>

                    <v-card elevation="10">
                      <v-card-title>
                        <v-icon large color="primary">
                          mdi-information-outline
                        </v-icon>
                        &nbsp; Do you want to remove the event?
                      </v-card-title>
                      <v-card-text>
                        <v-btn
                          color="primary"
                          @click.stop="deleteEvent(form.events[i])"
                        >
                          Yes
                        </v-btn>
                        &nbsp;
                        <v-btn color="red" dark @click.stop="closeEventDialogs">
                          No
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-col>
                <!-- /Delete Event Button -->
                <v-col cols="12" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open"></span>
                    <v-row v-else no-gutters style="width: 100%">
                      <v-col cols="6">
                        Total Tasks:{{ form.events[i].tasks?.length || 0 }}
                      </v-col>
                    </v-row>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <tasks
                class="pt-5"
                :form="form"
                :event="form.events[i]"
                :userItems="userItems"
              ></tasks>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <br />
    <v-btn
      class="mx-2"
      outlined
      small
      color="primary"
      @click="addEmptyEvent"
      v-if="userPermissions.find((up) => up == 'CREATE_EVENT')"
    >
      <v-icon dark> mdi-plus </v-icon> Add Event
    </v-btn>
    <br /><br />

    <!-- Event Concern Pop UP  -->
    <v-dialog
      v-model="show_details"
      transition="dialog-top-transition"
      max-width="800px"
    >
      <v-card elevation="2">
        <v-card-title>
          <span>
            <h2>{{ event_details.name }}</h2>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="(show_details = false), (event_details = [])">
            <v-icon>mdi-window-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-5">
          <v-row>
            <v-col
              md="12"
              v-for="(event_concern, tc) in event_details.event_concerns"
              :key="`event_concern${tc}`"
            >
              <v-card class="mx-auto" outlined>
                <v-card-title>
                  <span v-if="event_concern.user"
                    >{{ event_concern.user.first_name }}
                    {{ event_concern.user.last_name }}</span
                  >
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      v-html="event_concern.description"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- / Event Concern Pop UP -->
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import axios from "axios";
import tasks from "./tasks.vue";
import moment from "moment";
export default {
  components: { tasks },
  props: ["form", "userItems"],
  data() {
    return {
      count: "",
      isUpdating: false,
      show_details: false,
      isSavingEvent: false,
      isSendingEventSummary: false,
      isEventExcelLoading: false,
      is_select_all: false,
      generatingPDF: false,
      isDeleteEventDialogs: [],
      event_details: [],
      EventStatusItems: [
        { id: "0", text: "PENDING", value: 0 },
        { id: "1", text: "COMPLETED", value: 1 },
      ],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Status: "status",
        "Start Date": "start_date",
        "Follow Up Date": "end_date",
        Assignees: "assignees",
      },
      report_excel: [],
      title: "Event Report",
    };
  },
  methods: {
    addEmptyEvent() {
      let event = {
        board_id: this.form.id,
        name: "",
        isSendingEventSummary: false,
        status: 0,
        start_date: new Date(),
        next_scheduled_date: new Date(),
        next_scheduled_date_menu: false,
        event_attendees: [],
        event_concerns: [],
        Attendees: [],
        tasks: [],
      };
      this.form.events.push(event);
    },
    deleteEvent(event) {
      this.form.events.splice(this.form.events.indexOf(event), 1);
      event.is_deleted = true;
      this.save_event(event);
      this.closeEventDialogs();
    },
    closeEventDialogs() {
      this.isDeleteEventDialogs = [];
    },
    duplicateEvent(event) {
      let newEvent = Object.assign({}, event);
      newEvent.name = event.name + " copy";
      // newEvent.id = this.form.events.length;
      newEvent.id = "";
      newEvent.start_date = new Date();
      newEvent.status = 0;
      newEvent.next_scheduled_date = "";
      newEvent.tasks = [];
      newEvent.event_concerns = [];
      console.log(event);
      event.tasks.forEach((task) => {
        task.id = "";
        if (task.status != "Done") {
          newEvent.tasks.push(task);
        }
      });
      console.log(newEvent);
      this.form.events.push(newEvent);
    },
    remove_attendee(item, event) {
      // remove Attendee from Array
      const index = event.Attendees.indexOf(item.id);
      if (index >= 0) event.Attendees.splice(index, 1);
      // Save event
      this.save_event(event);
    },
    async save_event(event) {
      try {
        event.board_id = this.form.id;
        let event_attendees = [];
        if (event.Attendees) {
          event.Attendees.forEach((attendee_id) => {
            let event_attendee = event.event_attendees.find(
              (ta) => ta.attendee_id == attendee_id
            );
            if (event_attendee) {
              event_attendees.push(event_attendee);
            } else {
              let event_attendee = {
                event_id: event.id,
                attendee_id: attendee_id,
              };
              event_attendees.push(event_attendee);
            }
          });
          event.event_attendees = event_attendees;
        }
        this.isSavingEvent = true;
        let response = await axios.post("/events", event);
        event.id = response.data.data.id;
        this.isSavingEvent = false;
      } catch (e) {
        this.isSavingEvent = false;
      }
    },
    async SendEventSummary(id) {
      let event_details = this.form.events.find((event) => event.id == id);
      event_details.isSendingEventSummary = true;
      console.log(event_details);

      let event_ids = [];
      event_ids.push(id);
      await axios.post(`/events/send_summary?event_ids=${event_ids}`);
      // this.isSendingEventSummary = false;
      event_details.isSendingEventSummary = false;
      console.log(event_details);
    },
    // Trigger event Details Pop up
    async show_event_concerns(id) {
      this.event_details = [];
      this.event_details = this.form.events.filter(
        (event) => event.id == id
      )[0];
      if (this.event_details) {
        console.log(this.event_details);
        this.show_details = true;
      }
    },
    generateExcel(event_id) {
      this.isEventExcelLoading = true;
      let event_details = this.form.events.find(
        (event) => event.id == event_id
      );
      this.exportToExcel(event_details);
      this.isEventExcelLoading = false;
    },
    exportToExcel(event_details) {
      this.title =
        "Event Name: " +
        event_details.name +
        " Start Date & Time :" +
        moment(event_details.start_date).format("Y-MM-DD H:mm");
      this.report_excel = [];
      let sr_no = 1;
      event_details.tasks.forEach((task) => {
        let student_report = {
          sr_no: sr_no,
          name: task.name,
          status: task.status,
          start_date: task.start_date,
          end_date: task.end_date,
        };

        if (task.assignees) {
          student_report["assignees"] = task.assignees
            .map((assignee) => assignee.first_name + " " + assignee.last_name)
            .join(", ");
        } else {
          let assignees_array = [];
          task.task_assignees.forEach((assignee) => {
            let user = this.userItems.find(
              (user) => user.id == assignee.assignee_id
            );
            assignees_array.push(user.name);
            console.log(user);
          });
          student_report["assignees"] = assignees_array.join(", ");
        }
        this.report_excel.push(student_report);
        sr_no++;
      });
      this.event_details = [];
    },
    async ChangeEventStatus(event_id) {
      let event_details = this.form.events.find(
        (event) => event.id == event_id
      );
      let LastFollowupDate = "";
      if (event_details && event_details.tasks) {
        event_details.tasks.forEach((task) => {
          let end_date = moment(task.end_date, "YYYY-MM-DD");
          if (LastFollowupDate == "") {
            LastFollowupDate = end_date;
          } else {
            let diff = end_date.diff(LastFollowupDate, "days");
            if (diff > 0) {
              LastFollowupDate = end_date;
            }
          }
        });
      }
      event_details.next_scheduled_date =
        moment(LastFollowupDate).format("YYYY-MM-DD");
      this.save_event(event_details);
    },
    selectAll(event) {
      if (this.is_select_all == true) {
        this.userItems.forEach((user) => {
          let user_details = event.Attendees.find(
            (attendee) => attendee == user.id
          );
          if (!user_details) {
            event.Attendees.push(user.id);
          }
        });
      } else {
        event.Attendees = [];
      }
      this.save_event(event);
    },
    createPDF2(event) {
      this.generatingPDF = true;
      this.event_details = event;
      var element = document.getElementById("pdf-report");

      var opt = {
        margin: 10,
        filename: event.name + " Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: [220, 280],
          orientation: "portrait",
        },
      };
      html2pdf().set(opt).from(element).save();
      this.generatingPDF = false;
    },
  },
};
</script>
<style scoped>
.tb td {
  border: 1px solid #000000;
  padding: 5px;
}
</style>
